import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { updateContactSection } from "../../api/apiContactSection";
import parseError from "../../utils/parseError";

export const useUpdateContactSection = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const mutation = useMutation({
        mutationFn: (data) => updateContactSection(data),
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: ["contact-us-page"] });
            toast.success(
                response?.message ||
                (isArabic ? "تم تحديث إعدادات صفحة الاتصال" : "Contact section updated")
            );
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || (isArabic ? "تعذر التحديث" : "Failed to update"));
        },
    });

    return mutation;
};
